module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing_m.5f5eef5737f8bc3a8a539abbfdaacc92.png";